import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  resetTaxDeniedApprovalData,
  resetTaxMultiApprovalError,
} from "../../../../redux/features/transactions/taxTransaction/taxTransactionApproval";
import accountNameStandardised from "../../../../utils/accountNamestandardised";
import { GlobalConfiguration } from "../../../../utils/configurationProvider";
import formatDateViewAll from "../../../../utils/formatDateViewAll";
import CardContainer from "../../../_utils/CommonViewAllCard/CardContainer";
import TextWithCTA from "../../../_utils/CommonViewAllCard/CardSubComponent/TextWithCTA";
import TextWithIcon from "../../../_utils/CommonViewAllCard/CardSubComponent/TextWithIcon";

const TaxMultiApprovalCard = ({
  filterOpen,
  data,
  setselectAllCard,
  selectedTransactions,
  setSelectedTransactions,
  setTotalAmount,
  setSelectedSendTransactions,
  selectedSendTransactions,
  SideDrawerOpen,
  setTxnId,
  openBeneTxnDetailModal,
  scrollContainerRef,
}) => {
  const dispatch = useDispatch();

  const { tdsTransactionApproveError, tdsTransactionRejectError } = useSelector(
    (state) => state?.tdsTransactionApproval,
  );

  const getStatusColor = (status) => {
    switch (status) {
      case "pending":
        return "var(--pending)";
      case "approved":
        return "var(--settled)";
      case "denied":
      case "failed":
      case "rejected":
        return "var(--failed)";
      case "abandoned":
        return "var(--abandoned)";
      case "hold":
      case "queued":
        return "var(--queued)";
      default:
        return "var(--settled)";
    }
  };

  const handleCardClick = (account) => {
    if (account.tds_account_approval_status === "approved") {
      setselectAllCard(false);
      setSelectedTransactions((prevSelected) => {
        const cardAmount = Number(account.amount);
        const isSelected = prevSelected.includes(account.txn_id);

        if (isSelected) {
          setTotalAmount((prevAmount) => prevAmount - cardAmount);
          const newData = selectedSendTransactions.filter(
            (val) => val?.txn_id !== account.txn_id,
          );
          setSelectedSendTransactions(newData);
          return prevSelected.filter((id) => id !== account.txn_id);
        }
        if (prevSelected.length < GlobalConfiguration.categorymaxLength) {
          setTotalAmount((prevAmount) => prevAmount + cardAmount);
          setSelectedSendTransactions((prev) => [...prev, account]);
          return [...prevSelected, account.txn_id];
        }
        return prevSelected;
      });
    }
  };

  const handleCtaClick = (e, account) => {
    e.stopPropagation();

    if (!sessionStorage.getItem("q2p_token")) {
      return;
    }
    if (account.tds_account_approval_status === "pending") {
      SideDrawerOpen(account?.tds_account_id, account.txn_id);
    } else {
      openBeneTxnDetailModal();
      setTxnId(account.txn_id);
    }
  };

  useEffect(() => {
    dispatch(resetTaxMultiApprovalError());
    dispatch(resetTaxDeniedApprovalData());
  }, [tdsTransactionApproveError, tdsTransactionRejectError, dispatch]);

  return (
    <>
      <div className="standard-card-alignment gap-x-gap-sm gap-y-gap-md">
        {data?.map((account) => (
          <CardContainer
            isDisabled={
              filterOpen || account.tds_account_approval_status === "pending"
            }
            filterRef={scrollContainerRef}
            minHeight={GlobalConfiguration.BeneTxnCardMinHeight}
            hoverHeight={GlobalConfiguration.ownerAccountConnectedBankingLength}
            key={account?.txn_id}
            isSelected={selectedTransactions.includes(account.txn_id)}
            onClickHandler={() => handleCardClick(account)}
          >
            <card-body>
              <TextWithIcon
                type={
                  account.tds_account_approval_status === "pending"
                    ? "Text"
                    : "Amount"
                }
                fontWeight={"semibold"}
                text={
                  account.tds_account_approval_status === "pending"
                    ? "Account approval pending"
                    : account?.amount
                }
                textColor={getStatusColor(account.tds_account_approval_status)}
                subText={
                  account.tds_account_approval_status === "pending"
                    ? "Account status"
                    : "Amount"
                }
                iconComponentArray={
                  account.tds_account_approval_status !== "pending"
                    ? [
                        ...(account?.confidential_transaction === "Y"
                          ? [
                              {
                                icon: "https://q2pay.in/new_assets/common/detail_page/confidential_transaction.svg",
                                title: "confidential",
                                isDisabled: false,
                              },
                            ]
                          : []),
                        {
                          icon: selectedTransactions.includes(account?.txn_id)
                            ? "https://q2pay.in/new_assets/common/approval/selected_with_green_circle.svg"
                            : "https://q2pay.in/new_assets/common/view_all/not_selected_with_grey_circle.svg",
                          isDisabled: false,
                        },
                      ]
                    : []
                }
              />
              <TextWithIcon
                type={"Text"}
                fontWeight={"var(--font-normal)"}
                text={accountNameStandardised(account.tds_account_name)}
                textColor={"var(--text-primary)"}
                subText="Account name"
              />

              <TextWithCTA
                btnText={
                  account?.tds_account_approval_status === "pending"
                    ? "Approve account"
                    : "Additional details "
                }
                enabledBgColor={"var(--text-primary)"}
                enabledTextColor={"var(--primary-bg)"}
                handleFunction={(e) => handleCtaClick(e, account)}
                icon={
                  "https://q2pay.in/new_assets/common/arrows/arrow_right_white.svg"
                }
                isDisabled={!!filterOpen}
                text={
                  account.created_on
                    ? formatDateViewAll(account.created_on, false, false)
                    : "Not given"
                }
                subText="Date"
                type={"Text"}
              />
            </card-body>
            <card-hover>
              <TextWithIcon
                text={account?.labels?.join(", ") || "No labels assigned "}
                fontWeight={"normal"}
                textColor={"var(--text-primary)"}
                iconComponentArray={[
                  {
                    icon: "https://q2pay.in/new_assets/common/view_all/label.svg",
                  },
                ]}
              />
            </card-hover>
          </CardContainer>
        ))}
      </div>
    </>
  );
};

export default TaxMultiApprovalCard;
